import React, { useEffect } from 'react';
import { EspaceAtna } from '../components/espace/EspaceAtna';
import { ForYouFeed } from '../components/espace/ForYouFeed';
import { LocalNews, NearbyEvents, UsefulServices } from '../components/espace/LocalContent';
import { AppPromo } from '../components/espace/AppPromo';
import { citizenFirstName } from '../data/espace';
import { useEspace } from '../contexts/EspaceContext';
export function MonEspace() {
  const {
    enterEspace
  } = useEspace();
  useEffect(() => {
    enterEspace();
  }, [enterEspace]);
  return <main className="min-h-screen bg-white" data-id="element-2138" data-mp="12902oea1hyte">
      <div className="px-5 py-10 lg:px-10" data-id="element-2139" data-mp="nchn6guwosoh">
        <header data-id="element-2140" data-mp="nbprz7580wyq">
          <h1 className="text-3xl font-extrabold tracking-tight text-ville-navy lg:text-4xl" data-id="element-2141" data-mp="nbzg0p6pgu1s">
            Hello {citizenFirstName}
          </h1>
          <p className="mt-1 text-[17px] text-slate-600" data-id="element-2142" data-mp="381ynyynr334e">Here is what concerns you today.</p>
        </header>

        <div className="mt-6 max-w-3xl" data-id="element-2143" data-mp="3d1tdoyvshmnv">
          <EspaceAtna data-id="element-2144" data-mp="3czgnxzjsi809" />
        </div>

        <ForYouFeed data-id="element-2145" data-mp="1axbr7yfd2k71" />
        <LocalNews data-id="element-2146" data-mp="1aymrvpdifbtx" />
        <NearbyEvents data-id="element-2147" data-mp="1ay4wsw2l33nl" />
        <UsefulServices data-id="element-2148" data-mp="1azpjjzinpiaw" />
        <AppPromo data-id="element-2149" data-mp="15ys0zltqim8v" />
      </div>
    </main>;
}